package er.prateek.crossly.ui.screens.settings

import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import crossly.shared.generated.resources.reset_item_badges
import crossly.shared.generated.resources.reset_item_cannot_undo
import crossly.shared.generated.resources.reset_item_stars
import crossly.shared.generated.resources.reset_item_streak
import crossly.shared.generated.resources.reset_item_streak_none
import er.prateek.crossly.progression.achievements.Achievement
import er.prateek.crossly.ui.components.IconFlame
import er.prateek.crossly.ui.components.IconStar
import er.prateek.crossly.ui.components.IconTrophy
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import crossly.shared.generated.resources.Res
import crossly.shared.generated.resources.common_cancel
import crossly.shared.generated.resources.common_done
import crossly.shared.generated.resources.common_ok
import crossly.shared.generated.resources.settings_ads_free_active
import crossly.shared.generated.resources.settings_ads_remove_summary
import crossly.shared.generated.resources.settings_ads_restore
import crossly.shared.generated.resources.settings_ads_restore_none
import crossly.shared.generated.resources.settings_clue_gutter
import crossly.shared.generated.resources.settings_clue_gutter_summary
import crossly.shared.generated.resources.settings_crashlytics_test
import crossly.shared.generated.resources.settings_keyboard
import crossly.shared.generated.resources.settings_keyboard_full
import crossly.shared.generated.resources.settings_keyboard_relevant
import crossly.shared.generated.resources.settings_keyboard_summary
import crossly.shared.generated.resources.settings_keyboard_this_puzzle
import crossly.shared.generated.resources.settings_keyboard_word
import crossly.shared.generated.resources.settings_varies_by_level
import crossly.shared.generated.resources.settings_palette_classic
import crossly.shared.generated.resources.settings_palette_neon
import crossly.shared.generated.resources.settings_palette_ocean
import crossly.shared.generated.resources.settings_palette_sunset
import crossly.shared.generated.resources.settings_reset_progress
import crossly.shared.generated.resources.settings_reset_progress_confirm
import crossly.shared.generated.resources.settings_reset_progress_summary
import crossly.shared.generated.resources.settings_restart_note
import crossly.shared.generated.resources.settings_section_ads
import crossly.shared.generated.resources.settings_section_app
import crossly.shared.generated.resources.settings_coach_marks
import crossly.shared.generated.resources.settings_coach_marks_queued
import crossly.shared.generated.resources.settings_coach_marks_replay
import crossly.shared.generated.resources.settings_coach_marks_summary
import crossly.shared.generated.resources.settings_notifications
import crossly.shared.generated.resources.settings_notifications_summary
import crossly.shared.generated.resources.settings_section_data
import crossly.shared.generated.resources.settings_section_look
import crossly.shared.generated.resources.settings_section_play
import crossly.shared.generated.resources.settings_section_you
import crossly.shared.generated.resources.settings_share_app
import crossly.shared.generated.resources.settings_share_app_summary
import crossly.shared.generated.resources.settings_player_name
import crossly.shared.generated.resources.settings_player_name_summary
import crossly.shared.generated.resources.settings_player_name_unset
import crossly.shared.generated.resources.settings_privacy_policy
import crossly.shared.generated.resources.settings_privacy_policy_summary
import crossly.shared.generated.resources.settings_starters
import crossly.shared.generated.resources.settings_starters_few
import crossly.shared.generated.resources.settings_starters_many
import crossly.shared.generated.resources.settings_starters_none
import crossly.shared.generated.resources.settings_starters_summary
import crossly.shared.generated.resources.settings_theme_mode
import crossly.shared.generated.resources.settings_theme_mode_dark
import crossly.shared.generated.resources.settings_theme_mode_light
import crossly.shared.generated.resources.settings_theme_mode_system
import crossly.shared.generated.resources.settings_theme_palette
import crossly.shared.generated.resources.settings_title
import er.prateek.crossly.ads.entitlement.AdFreeProduct
import er.prateek.crossly.ads.entitlement.PurchaseResult
import er.prateek.crossly.config.AppConfig
import er.prateek.crossly.di.AppContainer
import er.prateek.crossly.firebase.AnalyticsEvents
import er.prateek.crossly.firebase.RemoteConfigKeys
import er.prateek.crossly.game.crossword.KeyboardMode
import er.prateek.crossly.game.crossword.StarterAmount
import er.prateek.crossly.notifications.NotificationPermissionProvider
import er.prateek.crossly.notifications.NotificationPermissionStatus
import er.prateek.crossly.ui.notifications.NotificationPermissionSheet
import er.prateek.crossly.ui.components.GameButton
import er.prateek.crossly.ui.components.GameButtonSize
import er.prateek.crossly.ui.components.GameButtonStyle
import er.prateek.crossly.ui.components.GameCard
import er.prateek.crossly.ui.components.GameScreen
import er.prateek.crossly.ui.components.GameTopBar
import er.prateek.crossly.ui.components.SegmentedControl
import er.prateek.crossly.ui.gameplay.GameplayState
import er.prateek.crossly.ui.share.NamePromptDialog
import er.prateek.crossly.ui.theme.PaletteId
import er.prateek.crossly.ui.theme.Spacing
import er.prateek.crossly.ui.theme.ThemeMode
import er.prateek.crossly.ui.theme.ThemeState
import er.prateek.crossly.ui.theme.game
import er.prateek.crossly.ui.theme.paletteFor
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

@Composable
fun SettingsScreen(
    themeState: ThemeState,
    gameplayState: GameplayState,
    onBack: () -> Unit,
    onOpenPrivacyPolicy: () -> Unit,
) {
    val colors = MaterialTheme.game
    val scope = rememberCoroutineScope()
    var showResetConfirm by remember { mutableStateOf(false) }
    var showNameDialog by remember { mutableStateOf(false) }
    var remindersEnabled by remember { mutableStateOf(AppContainer.notificationPrefsStore.remindersEnabledByUser()) }
    var showNotificationSheet by remember { mutableStateOf(false) }
    var shareAppAfterName by remember { mutableStateOf(false) }
    var playerName by remember { mutableStateOf(AppContainer.shareManager.playerName()) }
    // True once every tour is unseen -- right after a reset, or before any has been shown --
    // so the button reads as done instead of offering a reset that would change nothing.
    var coachMarksQueued by remember {
        val coach = AppContainer.coachPrefsStore
        mutableStateOf(!coach.hasSeenPlayCoach() && !coach.hasSeenLevelsCoach() && !coach.hasSeenResumeCoach())
    }

    // Read once per screen visit -- a config change lands next time Settings is opened,
    // same as everywhere else app_config is read.
    val gameplayConfig = remember { AppConfig.parse(AppContainer.remoteConfig.getString(RemoteConfigKeys.APP_CONFIG)).gameplay }
    val settingsVisibility = remember { AppConfig.parse(AppContainer.remoteConfig.getString(RemoteConfigKeys.APP_CONFIG)).settings }
    // Computed once per visit, so switching away from a no-longer-offered choice doesn't make
    // its segment vanish while Settings is still open.
    val visibleKeyboardModes = remember {
        visibleOptions(gameplayConfig.keyboardOptions.offered, gameplayState.keyboardModesInEffect())
    }
    val visibleStarterAmounts = remember {
        visibleOptions(gameplayConfig.starterOptions.offered, gameplayState.starterAmountsInEffect())
    }
    // Until the player picks, each level can be on its own config default -- then no single
    // segment is "the" choice, so none is highlighted and a note says why.
    val keyboardModesInEffect = gameplayState.keyboardModesInEffect()
    val starterAmountsInEffect = gameplayState.starterAmountsInEffect()

    GameScreen {
        Column(
            modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()),
            verticalArrangement = Arrangement.spacedBy(Spacing.lg),
        ) {
            GameTopBar(title = stringResource(Res.string.settings_title), onBack = onBack)

            SettingsSection(title = stringResource(Res.string.settings_section_you)) {
                OptionRow(
                    title = stringResource(Res.string.settings_player_name),
                    summary = stringResource(Res.string.settings_player_name_summary),
                ) {
                    GameButton(
                        text = playerName.ifBlank { stringResource(Res.string.settings_player_name_unset) },
                        onClick = { showNameDialog = true },
                        style = GameButtonStyle.SECONDARY,
                        fillWidth = true,
                    )
                }
            }

            SettingsSection(title = stringResource(Res.string.settings_section_app)) {
                OptionRow(
                    title = stringResource(Res.string.settings_share_app),
                    summary = stringResource(Res.string.settings_share_app_summary),
                ) {
                    GameButton(
                        text = stringResource(Res.string.settings_share_app),
                        onClick = {
                            AppContainer.analytics.logEvent(AnalyticsEvents.SETTINGS_SHARE_APP_TAPPED)
                            if (AppContainer.shareManager.hasPlayerName()) {
                                AppContainer.shareManager.shareApp(AppContainer.shareManager.playerName())
                            } else {
                                shareAppAfterName = true
                                showNameDialog = true
                            }
                        },
                        style = GameButtonStyle.PRIMARY,
                        fillWidth = true,
                    )
                }

                OptionRow(
                    title = stringResource(Res.string.settings_privacy_policy),
                    summary = stringResource(Res.string.settings_privacy_policy_summary),
                    modifier = Modifier.padding(top = Spacing.lg),
                ) {
                    GameButton(
                        text = stringResource(Res.string.settings_privacy_policy),
                        onClick = {
                            AppContainer.analytics.logEvent(AnalyticsEvents.SETTINGS_PRIVACY_POLICY_TAPPED)
                            onOpenPrivacyPolicy()
                        },
                        style = GameButtonStyle.SECONDARY,
                        fillWidth = true,
                    )
                }

                Row(
                    modifier = Modifier.fillMaxWidth().padding(top = Spacing.lg),
                    horizontalArrangement = Arrangement.spacedBy(Spacing.md),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            text = stringResource(Res.string.settings_notifications),
                            style = MaterialTheme.typography.titleSmall,
                            color = colors.ink,
                        )
                        Text(
                            text = stringResource(Res.string.settings_notifications_summary),
                            style = MaterialTheme.typography.bodySmall,
                            color = colors.inkMuted,
                        )
                    }
                    Switch(
                        checked = remindersEnabled,
                        onCheckedChange = { checked ->
                            remindersEnabled = checked
                            AppContainer.notificationCoordinator.setRemindersEnabledByUser(checked)
                            if (checked) {
                                scope.launch {
                                    val status = NotificationPermissionProvider.controller.currentStatus()
                                    if (status != NotificationPermissionStatus.GRANTED) showNotificationSheet = true
                                }
                            }
                        },
                        colors = SwitchDefaults.colors(
                            checkedThumbColor = colors.onAccent,
                            checkedTrackColor = colors.accent,
                        ),
                    )
                }
            }

            SettingsSection(title = stringResource(Res.string.settings_section_look)) {
                Text(
                    text = stringResource(Res.string.settings_theme_mode),
                    style = MaterialTheme.typography.titleSmall,
                    color = colors.ink,
                )
                SegmentedControl(
                    options = ThemeMode.entries,
                    selected = themeState.mode.value,
                    onSelect = {
                        val from = themeState.mode.value.name
                        themeState.setMode(it)
                        logSettingChanged("theme_mode", from, it.name)
                    },
                    modifier = Modifier.fillMaxWidth().padding(top = Spacing.sm),
                    label = { mode ->
                        stringResource(
                            when (mode) {
                                ThemeMode.SYSTEM -> Res.string.settings_theme_mode_system
                                ThemeMode.LIGHT -> Res.string.settings_theme_mode_light
                                ThemeMode.DARK -> Res.string.settings_theme_mode_dark
                            },
                        )
                    },
                )

                Text(
                    text = stringResource(Res.string.settings_theme_palette),
                    style = MaterialTheme.typography.titleSmall,
                    color = colors.ink,
                    modifier = Modifier.padding(top = Spacing.lg),
                )
                Row(
                    modifier = Modifier.fillMaxWidth().padding(top = Spacing.sm),
                    horizontalArrangement = Arrangement.spacedBy(Spacing.md),
                ) {
                    PaletteId.entries.forEach { paletteId ->
                        PaletteSwatch(
                            paletteId = paletteId,
                            label = stringResource(paletteLabel(paletteId)),
                            selected = themeState.paletteId.value == paletteId,
                            onClick = {
                                val from = themeState.paletteId.value.name
                                themeState.setPalette(paletteId)
                                logSettingChanged("theme_palette", from, paletteId.name)
                            },
                            modifier = Modifier.weight(1f),
                        )
                    }
                }
            }

            SettingsSection(title = stringResource(Res.string.settings_section_play)) {
                OptionRow(
                    title = stringResource(Res.string.settings_keyboard),
                    summary = stringResource(Res.string.settings_keyboard_summary),
                ) {
                    SegmentedControl(
                        options = visibleKeyboardModes,
                        selected = keyboardModesInEffect.singleOrNull(),
                        onSelect = { gameplayState.setKeyboardMode(it) },
                        modifier = Modifier.fillMaxWidth(),
                        label = { mode ->
                            stringResource(
                                when (mode) {
                                    KeyboardMode.FULL -> Res.string.settings_keyboard_full
                                    KeyboardMode.RELEVANT -> Res.string.settings_keyboard_relevant
                                    KeyboardMode.WORD -> Res.string.settings_keyboard_word
                                    KeyboardMode.THIS_PUZZLE -> Res.string.settings_keyboard_this_puzzle
                                },
                            )
                        },
                    )
                    if (keyboardModesInEffect.size > 1) VariesByLevelNote()
                }

                OptionRow(
                    title = stringResource(Res.string.settings_starters),
                    summary = stringResource(Res.string.settings_starters_summary),
                    modifier = Modifier.padding(top = Spacing.lg),
                ) {
                    SegmentedControl(
                        options = visibleStarterAmounts,
                        selected = starterAmountsInEffect.singleOrNull(),
                        onSelect = { gameplayState.setStarterAmount(it) },
                        modifier = Modifier.fillMaxWidth(),
                        label = { amount ->
                            stringResource(
                                when (amount) {
                                    StarterAmount.NONE -> Res.string.settings_starters_none
                                    StarterAmount.FEW -> Res.string.settings_starters_few
                                    StarterAmount.MANY -> Res.string.settings_starters_many
                                },
                            )
                        },
                    )
                    if (starterAmountsInEffect.size > 1) VariesByLevelNote()
                    Text(
                        text = stringResource(Res.string.settings_restart_note),
                        style = MaterialTheme.typography.bodySmall,
                        color = colors.inkMuted,
                        modifier = Modifier.padding(top = Spacing.sm),
                    )
                }

                Row(
                    modifier = Modifier.fillMaxWidth().padding(top = Spacing.lg),
                    horizontalArrangement = Arrangement.spacedBy(Spacing.md),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            text = stringResource(Res.string.settings_clue_gutter),
                            style = MaterialTheme.typography.titleSmall,
                            color = colors.ink,
                        )
                        Text(
                            text = stringResource(Res.string.settings_clue_gutter_summary),
                            style = MaterialTheme.typography.bodySmall,
                            color = colors.inkMuted,
                        )
                    }
                    Switch(
                        checked = gameplayState.showClueGutter.value,
                        onCheckedChange = {
                            val from = gameplayState.showClueGutter.value
                            gameplayState.setShowClueGutter(it)
                            logSettingChanged("clue_gutter", from.toString(), it.toString())
                        },
                        colors = SwitchDefaults.colors(
                            checkedThumbColor = colors.onAccent,
                            checkedTrackColor = colors.accent,
                        ),
                    )
                }

                if (settingsVisibility.showReplayCoachMarks) {
                    OptionRow(
                        title = stringResource(Res.string.settings_coach_marks),
                        summary = stringResource(Res.string.settings_coach_marks_summary),
                        modifier = Modifier.padding(top = Spacing.lg),
                    ) {
                        GameButton(
                            text = stringResource(
                                if (coachMarksQueued) Res.string.settings_coach_marks_queued else Res.string.settings_coach_marks_replay,
                            ),
                            onClick = {
                                AppContainer.coachPrefsStore.resetAll()
                                AppContainer.analytics.logEvent(AnalyticsEvents.COACH_MARKS_RESET)
                                coachMarksQueued = true
                            },
                            style = GameButtonStyle.SECONDARY,
                            enabled = !coachMarksQueued,
                            fillWidth = true,
                        )
                    }
                }
            }

            AdsSection()

            if (settingsVisibility.showResetProgress || settingsVisibility.showSendTestCrash) {
                SettingsSection(title = stringResource(Res.string.settings_section_data)) {
                    if (settingsVisibility.showResetProgress) {
                        Text(
                            text = stringResource(Res.string.settings_reset_progress_summary),
                            style = MaterialTheme.typography.bodySmall,
                            color = colors.inkMuted,
                            modifier = Modifier.padding(bottom = Spacing.md),
                        )
                        GameButton(
                            text = stringResource(Res.string.settings_reset_progress),
                            onClick = {
                                AppContainer.analytics.logEvent(AnalyticsEvents.RESET_PROGRESS_TAPPED)
                                showResetConfirm = true
                            },
                            style = GameButtonStyle.DANGER,
                            size = GameButtonSize.SMALL,
                        )
                    }
                    // Firebase's own documented pattern for verifying a Crashlytics integration end to
                    // end (see docs/PLAN.md's Phase 6 exit test) -- a genuine uncaught crash, not a
                    // recorded non-fatal, since that's what the exit test checks for in the console.
                    if (settingsVisibility.showSendTestCrash) {
                        GameButton(
                            text = stringResource(Res.string.settings_crashlytics_test),
                            onClick = {
                                AppContainer.analytics.logEvent(AnalyticsEvents.CRASH_TEST_TRIGGERED)
                                throw RuntimeException("Crossly: Settings > Send Test Crash Report")
                            },
                            style = GameButtonStyle.GHOST,
                            size = GameButtonSize.SMALL,
                            modifier = Modifier.padding(top = if (settingsVisibility.showResetProgress) Spacing.sm else 0.dp),
                        )
                    }
                }
            }

            GameButton(
                text = stringResource(Res.string.common_done),
                onClick = onBack,
                style = GameButtonStyle.PRIMARY,
                fillWidth = true,
                modifier = Modifier.padding(bottom = Spacing.lg),
            )
        }
    }

    if (showNameDialog) {
        NamePromptDialog(
            initialName = playerName,
            skipAllowed = false,
            onSave = { name ->
                playerName = AppContainer.shareManager.savePlayerName(name)
                AppContainer.analytics.logEvent(AnalyticsEvents.NAME_SAVED, mapOf("source" to "settings"))
                showNameDialog = false
                if (shareAppAfterName) {
                    shareAppAfterName = false
                    AppContainer.shareManager.shareApp(playerName)
                }
            },
            onSkip = {
                AppContainer.analytics.logEvent(AnalyticsEvents.NAME_SKIPPED, mapOf("source" to "settings"))
                showNameDialog = false
            },
            onDismiss = { showNameDialog = false },
        )
    }

    if (showResetConfirm) {
        AlertDialog(
            onDismissRequest = { showResetConfirm = false },
            containerColor = colors.card,
            shape = RoundedCornerShape(24.dp),
            title = {
                Text(stringResource(Res.string.settings_reset_progress), color = colors.ink)
            },
            text = { ResetConfirmBody() },
            confirmButton = {
                GameButton(
                    text = stringResource(Res.string.common_ok),
                    onClick = {
                        AppContainer.analytics.logEvent(
                            AnalyticsEvents.RESET_PROGRESS_CONFIRMED,
                            mapOf(
                                "stars_before" to AppContainer.progressionManager.totalStarsEarned(),
                                "current_streak_before" to AppContainer.dailyPuzzleManager.currentStreak().currentStreak,
                                "play_streak_before" to AppContainer.streakManager.displayStreak(),
                                "badges_before" to AppContainer.achievementManager.unlockedCount(),
                            ),
                        )
                        AppContainer.notificationPrefsStore.resetAll()
                        AppContainer.resetAllProgress()
                        remindersEnabled = AppContainer.notificationPrefsStore.remindersEnabledByUser()
                        showResetConfirm = false
                    },
                    style = GameButtonStyle.DANGER,
                    size = GameButtonSize.SMALL,
                )
            },
            dismissButton = {
                GameButton(
                    text = stringResource(Res.string.common_cancel),
                    onClick = {
                        AppContainer.analytics.logEvent(AnalyticsEvents.RESET_PROGRESS_CANCELLED)
                        showResetConfirm = false
                    },
                    style = GameButtonStyle.GHOST,
                    size = GameButtonSize.SMALL,
                )
            },
        )
    }

    if (showNotificationSheet) {
        NotificationPermissionSheet(
            onTurnOnReminders = {
                AppContainer.notificationCoordinator.onSoftAskSettingsTapped()
                showNotificationSheet = false
            },
            onDismiss = {
                AppContainer.notificationCoordinator.onSoftAskDismissed()
                showNotificationSheet = false
            },
        )
    }
}

/**
 * The paid ad-free tier's home in the UI.
 *
 * Renders nothing at all while nothing is on sale and the user has no entitlement, which is
 * the current state everywhere -- there is no "coming soon" teaser, because a settings row
 * that can't be acted on is just clutter. Binding a real PurchaseGateway in AppContainer is
 * what brings this section to life; no change here is needed.
 */
@Composable
private fun AdsSection() {
    val colors = MaterialTheme.game
    val scope = rememberCoroutineScope()
    val entitlement by AppContainer.adsCoordinator.entitlement.collectAsStateWithLifecycle()

    var products by remember { mutableStateOf<List<AdFreeProduct>>(emptyList()) }
    var restoreMessage by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(Unit) {
        products = AppContainer.entitlementProvider.products()
    }

    if (!entitlement.adFree && products.isEmpty()) return

    SettingsSection(title = stringResource(Res.string.settings_section_ads)) {
        if (entitlement.adFree) {
            Text(
                text = stringResource(Res.string.settings_ads_free_active),
                style = MaterialTheme.typography.bodyMedium,
                color = colors.ink,
            )
            return@SettingsSection
        }

        Text(
            text = stringResource(Res.string.settings_ads_remove_summary),
            style = MaterialTheme.typography.bodySmall,
            color = colors.inkMuted,
            modifier = Modifier.padding(bottom = Spacing.md),
        )
        products.forEach { product ->
            GameButton(
                // The store's own formatted price, never one assembled here -- currency,
                // placement and locale are the store's to decide.
                text = "${product.title} · ${product.formattedPrice}",
                onClick = {
                    AppContainer.analytics.logEvent(
                        AnalyticsEvents.ENTITLEMENT_PURCHASE_STARTED,
                        mapOf("product_id" to product.id, "price" to product.formattedPrice, "recurring" to product.recurring),
                    )
                    scope.launch {
                        when (val result = AppContainer.entitlementProvider.purchase(product.id)) {
                            is PurchaseResult.Success -> {
                                AppContainer.analytics.logEvent(
                                    AnalyticsEvents.ENTITLEMENT_PURCHASE_COMPLETED,
                                    mapOf("product_id" to product.id, "source" to result.entitlement.source.name),
                                )
                            }
                            is PurchaseResult.Failed -> {
                                AppContainer.analytics.logEvent(
                                    AnalyticsEvents.ENTITLEMENT_PURCHASE_FAILED,
                                    mapOf("product_id" to product.id, "reason" to result.message),
                                )
                            }
                            is PurchaseResult.Cancelled -> {
                                AppContainer.analytics.logEvent(
                                    AnalyticsEvents.ENTITLEMENT_PURCHASE_FAILED,
                                    mapOf("product_id" to product.id, "reason" to "cancelled"),
                                )
                            }
                            is PurchaseResult.Unavailable -> {
                                AppContainer.analytics.logEvent(
                                    AnalyticsEvents.ENTITLEMENT_PURCHASE_FAILED,
                                    mapOf("product_id" to product.id, "reason" to "unavailable"),
                                )
                            }
                        }
                    }
                },
                style = GameButtonStyle.PRIMARY,
                fillWidth = true,
            )
        }
        // Required by App Store review for any non-consumable, and the only way a user who
        // reinstalls gets back what they paid for.
        GameButton(
            text = stringResource(Res.string.settings_ads_restore),
            onClick = {
                AppContainer.analytics.logEvent(AnalyticsEvents.ENTITLEMENT_RESTORE_STARTED)
                scope.launch {
                    val restored = AppContainer.entitlementProvider.restore()
                    AppContainer.analytics.logEvent(
                        AnalyticsEvents.ENTITLEMENT_RESTORE_COMPLETED,
                        mapOf("restored" to restored.adFree, "source" to restored.source.name),
                    )
                    restoreMessage = if (restored.adFree) null else "restore_none"
                }
            },
            style = GameButtonStyle.GHOST,
            size = GameButtonSize.SMALL,
            modifier = Modifier.padding(top = Spacing.sm),
        )
        if (restoreMessage != null) {
            Text(
                text = stringResource(Res.string.settings_ads_restore_none),
                style = MaterialTheme.typography.bodySmall,
                color = colors.inkMuted,
                modifier = Modifier.padding(top = Spacing.xs),
            )
        }
    }
}

/** Title, one line of "what this actually does", then the control itself. */
@Composable
private fun OptionRow(
    title: String,
    summary: String,
    modifier: Modifier = Modifier,
    control: @Composable androidx.compose.foundation.layout.ColumnScope.() -> Unit,
) {
    val colors = MaterialTheme.game
    Column(modifier = modifier.fillMaxWidth()) {
        Text(
            text = title,
            style = MaterialTheme.typography.titleSmall,
            color = colors.ink,
        )
        Text(
            text = summary,
            style = MaterialTheme.typography.bodySmall,
            color = colors.inkMuted,
            modifier = Modifier.padding(top = Spacing.xxs, bottom = Spacing.sm),
        )
        control()
    }
}

@Composable
private fun VariesByLevelNote() {
    Text(
        text = stringResource(Res.string.settings_varies_by_level),
        style = MaterialTheme.typography.bodySmall,
        color = MaterialTheme.game.inkMuted,
        modifier = Modifier.padding(top = Spacing.sm),
    )
}

@Composable
private fun SettingsSection(
    title: String,
    content: @Composable androidx.compose.foundation.layout.ColumnScope.() -> Unit,
) {
    val colors = MaterialTheme.game
    Column(verticalArrangement = Arrangement.spacedBy(Spacing.sm)) {
        Text(
            text = title.uppercase(),
            style = MaterialTheme.typography.labelSmall,
            color = colors.inkMuted,
            modifier = Modifier.padding(start = Spacing.xs),
        )
        GameCard(modifier = Modifier.fillMaxWidth(), content = content)
    }
}

/**
 * Live preview of each palette: the swatch is painted with that palette's own
 * accent gradient, so the choice is made by looking rather than by reading a
 * name and guessing.
 */
@Composable
private fun PaletteSwatch(
    paletteId: PaletteId,
    label: String,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val colors = MaterialTheme.game
    // Previewed in the palette's own light/dark variant matching the app's
    // current brightness, so swatches don't lie about what tapping will do.
    val isDark = colors.backdropBottom.luminanceIsDark()
    val preview = paletteFor(paletteId).colors(isDark)

    val ringWidth by animateDpAsState(if (selected) 3.dp else 1.5.dp, tween(200), label = "swatchRing")

    Column(
        modifier = modifier.clickable(onClick = onClick),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(Spacing.sm),
    ) {
        Box(
            modifier = Modifier
                .size(52.dp)
                .clip(CircleShape)
                .background(Brush.linearGradient(listOf(preview.accent, preview.accentAlt)))
                .border(ringWidth, if (selected) colors.ink else colors.cardBorder, CircleShape),
        )
        Text(
            text = label,
            style = MaterialTheme.typography.labelSmall,
            color = if (selected) colors.ink else colors.inkMuted,
        )
    }
}

/** Rough perceptual check — good enough to pick which variant to preview. */
private fun androidx.compose.ui.graphics.Color.luminanceIsDark(): Boolean =
    (0.299f * red + 0.587f * green + 0.114f * blue) < 0.5f

private fun paletteLabel(paletteId: PaletteId) = when (paletteId) {
    PaletteId.CLASSIC -> Res.string.settings_palette_classic
    PaletteId.OCEAN -> Res.string.settings_palette_ocean
    PaletteId.SUNSET -> Res.string.settings_palette_sunset
    PaletteId.NEON -> Res.string.settings_palette_neon
}

/**
 * Which segments Settings offers, in enum order -- always including every value currently in
 * effect on some level, so a choice a player already has never disappears out from under them
 * just because a later config stopped offering it.
 */
private inline fun <reified T : Enum<T>> visibleOptions(offered: Set<T>, inEffect: Set<T>): List<T> =
    enumValues<T>().filter { it in offered || it in inEffect }

private fun logSettingChanged(setting: String, from: String, to: String) {
    AppContainer.analytics.logEvent(
        AnalyticsEvents.SETTINGS_CHANGED,
        mapOf("setting" to setting, "from_value" to from, "to_value" to to),
    )
}

/** Spells out exactly what a reset takes away, with the player's own numbers. */
@Composable
private fun ResetConfirmBody() {
    val colors = MaterialTheme.game
    val streak = AppContainer.streakManager
    val badges = AppContainer.achievementManager
    val stars = AppContainer.progressionManager.totalStarsEarned() +
        AppContainer.mathProgressionManager.totalStars() +
        AppContainer.riddleProgressionManager.totalStars()
    val current = streak.displayStreak()
    val best = maxOf(streak.streak.longest, current)
    Column(verticalArrangement = Arrangement.spacedBy(Spacing.sm)) {
        Text(stringResource(Res.string.settings_reset_progress_confirm), color = colors.inkMuted)
        ResetItem(colors.gold, stringResource(Res.string.reset_item_stars, stars)) { tint -> IconStar(size = 16.dp, tint = tint) }
        ResetItem(
            colors.flame,
            if (current > 0) stringResource(Res.string.reset_item_streak, current, best) else stringResource(Res.string.reset_item_streak_none, best),
        ) { tint -> IconFlame(size = 16.dp, tint = tint) }
        ResetItem(
            colors.accent,
            stringResource(Res.string.reset_item_badges, badges.unlockedCount(), Achievement.entries.size),
        ) { tint -> IconTrophy(size = 16.dp, tint = tint) }
        Text(
            stringResource(Res.string.reset_item_cannot_undo),
            color = colors.danger,
            style = MaterialTheme.typography.labelLarge,
            modifier = Modifier.padding(top = Spacing.xs),
        )
    }
}

@Composable
private fun ResetItem(tint: Color, text: String, icon: @Composable (Color) -> Unit) {
    val colors = MaterialTheme.game
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(Spacing.sm)) {
        icon(tint)
        Text(text, color = colors.ink, style = MaterialTheme.typography.bodyMedium)
    }
}
